
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subsidies",
      function () {
        return require("private-next-pages/subsidies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subsidies"])
      });
    }
  